import { api } from "@/services/api";

export interface IntegrityStatus {
  ok: boolean;
  error?: string;
  message?: string;
  generatedAt?: string | null;
  lastCheckedAt?: string;
  changed?: { path: string; before: string; after: string }[];
  added?: string[];
  removed?: string[];
  tracked?: number;
}

export interface SecurityAlert {
  id: number;
  category: string;
  severity: string;
  source: string | null;
  entity_type: string | null;
  entity_id: string | null;
  title: string;
  details: string | null;
  matched_pattern: string | null;
  snippet: string | null;
  status: string;
  created_at: string;
}

export interface SecurityStatus {
  counts: { open: number; resolved: number; dismissed: number };
  bySeverity: { low: number; medium: number; high: number; critical: number };
  lastScan: string | null;
  integrity: IntegrityStatus;
  headers: Record<string, boolean>;
}

export interface ScanResult {
  newAlerts: number;
  scanned: { leads: number; content_blocks: number; pages: number; files: number };
  integrity: IntegrityStatus;
  openCount: number;
}

export const securityApi = {
  status: () => api.get<SecurityStatus>("/security/status"),
  alerts: (params?: { status?: string; category?: string }) => {
    const q = new URLSearchParams();
    if (params?.status) q.set("status", params.status);
    if (params?.category) q.set("category", params.category);
    const qs = q.toString();
    return api.get<SecurityAlert[]>(`/security/alerts${qs ? `?${qs}` : ""}`);
  },
  scan: () => api.post<ScanResult>("/security/scan", {}),
  resolve: (id: number, status = "resolved") =>
    api.post<SecurityAlert>(`/security/alerts/${id}/resolve`, { status }),
  recreateBaseline: () => api.post<{ created: boolean; count: number }>("/security/baseline/recreate", {}),
};